type CommitmentPartnerFlags = {
  isCarryPartnerCommitment?: boolean;
  isGeneralPartnerCommitment?: boolean;
};

type ExclusionSettings = {
  excludeCarryPartnerFromAllocations: boolean;
  excludeGeneralPartnerFromAllocations: boolean;
};

const isSystemExcludedCommitment = (
  commitment: CommitmentPartnerFlags,
  exclusionSettings: ExclusionSettings,
): boolean => {
  if (
    commitment.isCarryPartnerCommitment &&
    exclusionSettings.excludeCarryPartnerFromAllocations
  )
    return true;
  if (
    commitment.isGeneralPartnerCommitment &&
    exclusionSettings.excludeGeneralPartnerFromAllocations
  )
    return true;
  return false;
};

export default isSystemExcludedCommitment;
